import React, { useState } from 'react'
import "./Navbar.css"
import { TbBrandDiscord } from "react-icons/tb"
import { AiOutlineInstagram } from "react-icons/ai"
import { FiTwitter } from "react-icons/fi"
import { Link } from 'react-scroll'
const Navbar = () => {
    
    const[scroll,setScrolle] = useState(false);
   
    window.onscroll = ()=>{
        setScrolle(window.pageYOffset>0?true:false)
        return ()=> window.onscroll = null;
    };
  

    return (
        <div className={`flex flex-col h-auto w-screen ${scroll?"main-bg":"bg-transparent"}  fixed z-[999]  justify-evenly items-center`}>
            <div className='flex flex-row w-full h-[85px] justify-between'>
                <div className='flex flex-col flex-wrap w-[100px] mx-10 my-10 justify-center items-center logo-container  cursor-pointer'>

                    <img src={require("../../assets/images/Scribs-logo-2.png")} alt='logo' className='' />
                </div>
                <div className='flex flex-row mx-10 text-white justify-center items-center flex-wrap  font-turrent'>

                    <ul className='flex flex-row uppercase text-xl  font-bold'>
                        <li className='flex flex-row mx-5 py-2 nav_item relative cursor-pointer'><Link to="home" spy={true} smooth={true} offset={0} duration={900} className='tracking-[5px]'>Home</Link></li>
                        <li className='flex flex-row mx-5 py-2 nav_item relative cursor-pointer'><Link to="about" spy={true} smooth={true} offset={0} duration={900} className=' tracking-[5px]'>About</Link></li>
                        <li className='flex flex-row mx-5 py-2 nav_item relative cursor-pointer'><Link to="story" spy={true} smooth={true} offset={0} duration={900} className=' tracking-[5px]'>Story</Link></li>
                        <li className='flex flex-row mx-5 py-2 nav_item relative cursor-pointer'><Link to="mint" spy={true} smooth={true} offset={0} duration={900} className=' tracking-[5px]'>Mint</Link></li>
                        <li className='flex flex-row mx-5 py-2 nav_item relative cursor-pointer'><Link to="roadmap" spy={true} smooth={true} offset={0} duration={900} className=' tracking-[5px]'>Roadmap</Link></li>
                        <li className='flex flex-row mx-5 py-2 nav_item relative cursor-pointer'><Link to="faq" spy={true} smooth={true} offset={0} duration={900} className=' tracking-[5px]'>FAQ</Link></li>
                    </ul>

                    <div className='flex flex-row flex-wrap text-2xl ml-20 '>
                        <AiOutlineInstagram className=' mx-4 cursor-pointer media' />
                        <FiTwitter className=' mx-4 cursor-pointer media' />
                        <TbBrandDiscord className=' mx-4 cursor-pointer media' />
                    </div>

                </div>
            </div>
        </div>
    )
}

export default Navbar